import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Package } from "@phosphor-icons/react";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center text-stone-400">Cargando...</div>;

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-12" data-testid="orders-page">
      <h1 className="font-serif text-4xl md:text-5xl text-stone-900 mb-10">Mis pedidos</h1>
      {orders.length === 0 ? (
        <div className="text-center py-20" data-testid="no-orders">
          <Package size={48} className="mx-auto text-stone-300" />
          <p className="text-stone-500 mt-4">Aún no tienes pedidos.</p>
          <Link to="/shop" className="inline-block mt-6 bg-[#3F4E4F] text-white px-8 py-3 hover:bg-[#2C3637]">Ir a la tienda</Link>
        </div>
      ) : (
        <div className="space-y-6">
          {orders.map((o) => (
            <div key={o.id} className="bg-white border border-stone-200 p-6" data-testid={`order-${o.id}`}>
              <div className="flex justify-between items-start mb-4 pb-4 border-b border-stone-100">
                <div>
                  <div className="label-caps text-stone-400">Pedido</div>
                  <div className="text-stone-900 font-medium">#{o.id.slice(-8).toUpperCase()}</div>
                  <div className="text-xs text-stone-400 mt-1">{new Date(o.created_at).toLocaleDateString("es")}</div>
                </div>
                <div className="text-right">
                  <span className="inline-block bg-[#166534]/10 text-[#166534] text-xs px-3 py-1 rounded-full capitalize">{o.status}</span>
                  <div className="text-lg font-medium text-stone-900 mt-2">${o.amount?.toFixed(2)}</div>
                </div>
              </div>
              <div className="space-y-2">
                {o.items?.map((it, idx) => (
                  <div key={idx} className="flex justify-between text-sm text-stone-600">
                    <span>{it.name} × {it.quantity}</span>
                    <span>${(it.price * it.quantity).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
